import type { ComponentType } from 'react'
import { Helmet } from 'react-helmet'
import Head from "next/head"

interface Props {
  $t: any
}

const CommonMeta: ComponentType<Props> = (props: Props) => {
  const { $t } = props
  const ResUnim = $t('ResUnim.global')
  return <>
    <Helmet
      meta={[
        { charSet: 'utf-8' },
        { httpEquiv: 'X-UA-Compatible', content: 'IE=edge,chrome=1' },
        { name: 'viewport',content: 'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no'},
        { name: 'description', content: ResUnim.__seoDesc },
        { name: 'keywords', content: ResUnim.__seoKeyword },
        { itemprop: 'name', content: `${ResUnim.__seoTitle} | 17TRACK` },
        { itemprop: 'description', content: ResUnim.__seoDesc },
        { itemprop: 'url', content: 'https://www.17track.net' },
        { itemprop: 'image', content: 'https://res.17track.net/global-v2/imgs/oauth_image/share.png' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://m.17track.net' },
        { property: 'og:title', content: ResUnim.__seoTitle },
        { property: 'og:description', content: ResUnim.__seoDesc },
        { property: 'og:image', content: 'https://res.17track.net/global-v2/imgs/oauth_image/share.png' },
        { name: 'msapplication-TileColor', content: '#003A9B' },
        { name: 'theme-color', content: '#003A9B' },
        { name: 'author', content: 'admin@17track.net' },
        { name: 'msapplication-tap-highlight', content: 'no' },
        { name: 'apple-itunes-app', content: 'app-id=1004956012' },
        { name: 'google-play-app', content: 'app-id=yqtrack.app' },
        { name: 'msApplication-ID', content: '17TRACK.17TRACK' },
        { name: 'msApplication-PackageFamilyName', content: '17TRACK.17TRACK_vs3bzqqr3bhre' },
        { name: 'qc:admins', content: '1027553633526174213366547' }
    ]}
    />
    <Head>
      <title>{ResUnim.__seoTitle} | 17TRACK</title>
    </Head>
  </> 
}

export default CommonMeta

module.exports = CommonMeta